function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M279.269 472.001C433.504 472.001 558.537 461.914 558.537 449.471C558.537 437.029 433.504 426.942 279.269 426.942C125.033 426.942 0 437.029 0 449.471C0 461.914 125.033 472.001 279.269 472.001Z",
  fill: "#E9E9E9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M497.447 462.088C451.91 452.882 402.114 454.412 349.879 462.088C373.687 439.258 394.234 416.429 370.427 393.599C416.867 404.481 423.371 403.38 475.032 393.599C463.05 416.429 485.465 439.258 497.447 462.088Z",
  fill: "#00426C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M497.447 462.088C451.91 452.882 402.114 454.412 349.879 462.088C373.687 439.258 394.234 416.429 370.427 393.599C416.867 404.481 423.371 403.38 475.032 393.599C463.05 416.429 485.465 439.258 497.447 462.088Z",
  fill: "#1F7DA2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M486.34 452.346C447.658 444.998 405.358 446.22 360.987 452.346C381.21 434.123 398.665 415.9 378.441 397.677C417.89 406.364 423.415 405.485 467.299 397.677C457.121 415.9 476.162 434.123 486.34 452.346Z",
  fill: "#00426C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M471.607 422.985C482.99 422.985 492.217 412.503 492.217 399.574C492.217 386.644 482.99 376.163 471.607 376.163C460.224 376.163 450.996 386.644 450.996 399.574C450.996 412.503 460.224 422.985 471.607 422.985Z",
  fill: "#252439"
}), /*#__PURE__*/React.createElement("path", {
  d: "M378.044 372.421L392.325 375.125L399.465 398.555L378.838 412.974L355.036 372.421H377.251H378.044Z",
  fill: "#7C5D62"
}), /*#__PURE__*/React.createElement("path", {
  d: "M418.507 408.467C436.91 408.467 451.828 391.521 451.828 370.618C451.828 349.715 436.91 332.769 418.507 332.769C400.103 332.769 385.185 349.715 385.185 370.618C385.185 391.521 400.103 408.467 418.507 408.467Z",
  fill: "#7C5D62"
}), /*#__PURE__*/React.createElement("path", {
  d: "M234.443 232.739C234.443 232.739 153.518 242.652 139.237 240.85C124.957 239.048 118.609 237.245 118.609 237.245C118.609 237.245 109.089 251.664 113.849 257.972C116.515 261.607 119.741 264.661 123.37 266.984C123.37 266.984 132.097 264.28 138.444 266.984C144.791 269.687 209.055 281.402 220.162 270.588C231.269 259.774 234.443 232.739 234.443 232.739Z",
  fill: "#363537"
}), /*#__PURE__*/React.createElement("path", {
  d: "M239.997 433.701C239.997 433.701 186.84 416.578 177.32 340.88V333.671C177.32 333.671 166.802 354.629 163.039 358.904C158.675 363.86 143.205 408.468 143.998 412.974C144.791 417.48 143.998 419.282 143.998 419.282L120.99 416.579V408.468C120.99 408.468 133.287 366.564 134.081 356.651C134.874 346.738 164.626 277.799 164.626 277.799C164.626 277.799 175.733 251.665 194.774 277.799C213.815 303.933 215.402 321.956 215.402 321.956L239.996 376.026L239.997 433.701Z",
  fill: "#363537"
}), /*#__PURE__*/React.createElement("path", {
  d: "M120.99 234.542L95.6016 224.629C95.6016 224.629 71.8003 204.803 77.354 224.629C82.9076 244.455 108.296 287.711 115.436 283.205C122.576 278.699 131.164 267.515 129.25 265.898C127.337 264.28 114.643 252.565 120.99 234.542Z",
  fill: "#797979"
}), /*#__PURE__*/React.createElement("path", {
  d: "M124.058 403.147L103.564 414.516C103.564 414.516 78.78 418.847 92.6018 426.967C106.424 435.088 144.553 443.75 146.459 436.17C148.366 428.591 147.609 416.013 145.605 416.347C143.6 416.681 129.778 418.305 124.058 403.147Z",
  fill: "#797979"
}), /*#__PURE__*/React.createElement("path", {
  d: "M229.683 374.223C229.683 374.223 219.369 424.688 236.823 435.502C254.278 446.316 376.458 448.119 385.978 428.293C395.499 408.467 390.739 408.467 390.739 408.467L365.35 376.025L385.978 374.223C385.978 374.223 385.978 367.013 378.838 366.112C371.697 365.211 349.483 356.199 330.442 362.508C311.401 368.816 300.294 349.891 300.294 349.891L229.683 374.223Z",
  fill: "#F9F9F9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M216.195 216.52L202.707 300.329L295.533 287.712L312.194 212.014L216.195 216.52Z",
  fill: "#363537"
}), /*#__PURE__*/React.createElement("path", {
  d: "M218.972 219.672L207.865 294.469L292.359 283.205L308.623 215.167L218.972 219.672Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M205.881 301.228L202.708 300.327L201.121 303.931L226.51 384.135L228.897 383.099L229.683 377.828L205.881 301.228Z",
  fill: "#B3B3B3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M202.707 299.426L228.096 383.235L324.094 367.014L295.533 287.711L202.707 299.426Z",
  fill: "#B7B7B7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M215.402 296.723V301.229L286.012 292.217L285.219 287.711L215.402 296.723Z",
  fill: "#3F3D56"
}), /*#__PURE__*/React.createElement("path", {
  d: "M216.988 305.734L228.096 340.879L300.293 330.967L287.599 297.623L216.988 305.734Z",
  fill: "#363537"
}), /*#__PURE__*/React.createElement("path", {
  d: "M307.434 355.3L305.053 348.09C305.053 348.09 286.806 312.044 277.285 319.253C267.765 326.462 297.12 361.608 297.12 361.608H306.64L307.434 355.3Z",
  fill: "#7C5D62"
}), /*#__PURE__*/React.createElement("path", {
  d: "M247.137 360.706L244.757 349.892C244.757 349.892 238.41 316.548 249.517 318.351C260.625 320.153 263.798 351.694 263.798 351.694L263.005 358.903L247.137 360.706Z",
  fill: "#7C5D62"
}), /*#__PURE__*/React.createElement("path", {
  d: "M266.178 356.201C266.178 356.201 245.551 352.596 244.757 358.003C243.964 363.41 239.997 444.515 259.831 447.219C279.666 449.922 378.044 461.637 367.73 433.701C357.417 405.765 341.549 409.37 341.549 409.37L274.112 417.48L266.178 356.201Z",
  fill: "#F9F9F9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M328.458 366.563L307.434 349.891L293.55 362.057L311.004 383.685L328.458 366.563Z",
  fill: "#F9F9F9"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M272.129 382.784L275.302 417.028L330.045 413.423L282.442 412.522L272.129 382.784Z",
  fill: "#8F8F8F"
}), /*#__PURE__*/React.createElement("path", {
  d: "M434.955 422.554C456.864 422.554 474.624 402.38 474.624 377.495C474.624 352.61 456.864 332.437 434.955 332.437C413.047 332.437 395.286 352.61 395.286 377.495C395.286 402.38 413.047 422.554 434.955 422.554Z",
  fill: "#252439"
}), /*#__PURE__*/React.createElement("path", {
  d: "M230.873 245.807L280.062 243.862L284.822 223.278L234.046 225.019L230.873 245.807Z",
  fill: "#D89F0E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M218.179 257.522L292.756 254.818L293.55 251.214L218.973 254.196L218.179 257.522Z",
  fill: "#E6E6E6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M216.592 266.535L291.17 263.831L291.963 260.226L217.385 263.209L216.592 266.535Z",
  fill: "#E6E6E6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M215.798 273.742L290.376 271.039L291.169 267.434L216.592 270.416L215.798 273.742Z",
  fill: "#E6E6E6"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0H564V472H0V0Z",
  fill: "white"
})));

var SvgGirlComptr = function SvgGirlComptr(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 604,
    height: 605,
    viewBox: "0 0 564 472",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGirlComptr, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/GirlComptr.ca937901.svg";
export { ForwardRef as ReactComponent };